import { cva, type VariantProps } from 'class-variance-authority';
import * as React from 'react';

import { GAP_SCALE, SIZE_SCALE } from '@/components/design-system/tokens';
import { cn } from '@/lib/utils';

const kbdVariants = cva(
  `pointer-events-none inline-flex select-none items-center justify-center ${GAP_SCALE['1']} rounded border bg-muted px-1.5 py-0.5 font-medium font-mono text-3xs leading-none ${SIZE_SCALE.minW20} ${SIZE_SCALE['5']}`,
  {
    variants: {
      variant: {
        default: '',
        outline: 'border-2',
      },
    },
    defaultVariants: {
      variant: 'default',
    },
  }
);

type KbdProps = React.HTMLAttributes<HTMLElement> & VariantProps<typeof kbdVariants>;

const Kbd = React.forwardRef<HTMLElement, KbdProps>(({ className, variant, ...props }, ref) => {
  return <kbd className={cn(kbdVariants({ variant }), className)} ref={ref} {...props} />;
});
Kbd.displayName = 'Kbd';

type KbdGroupProps = React.HTMLAttributes<HTMLDivElement>;

const KbdGroup = React.forwardRef<HTMLDivElement, KbdGroupProps>(({ className, ...props }, ref) => {
  return (
    <div className={cn(`flex items-center ${GAP_SCALE['0.5']}`, className)} ref={ref} {...props} />
  );
});
KbdGroup.displayName = 'KbdGroup';

export { Kbd, KbdGroup };
